'use client';

import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient, SupabaseClientOptions } from '@supabase/supabase-js';

import { AUTH_SESSION_MAX_AGE_SECONDS, getSupabaseClientEnv, type SupabaseAppTarget } from '../config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SupabaseGenericClient = SupabaseClient<any, any, any, any, any>;

const browserClients = new Map<string, SupabaseGenericClient>();
const clientKey = (app?: SupabaseAppTarget) => (app ? `browser-${app}` : 'browser-default');

export const getSupabaseBrowserClient = (
  app?: SupabaseAppTarget,
  options?: SupabaseClientOptions<string>,
): SupabaseGenericClient => {
  const key = clientKey(app);
  const existing = browserClients.get(key);

  if (existing) {
    return existing;
  }

  const env = getSupabaseClientEnv(app);
  const client = createBrowserClient(env.supabaseUrl, env.supabaseAnonKey, {
    auth: {
      flowType: 'pkce',
      detectSessionInUrl: true,
      autoRefreshToken: true,
      persistSession: true,
    },
    cookieOptions: {
      path: '/',
      sameSite: 'lax',
      maxAge: AUTH_SESSION_MAX_AGE_SECONDS,
    },
    ...options,
  });

  browserClients.set(key, client as SupabaseGenericClient);

  return client;
};
